export default "__VITE_ASSET__CxcFGCJq__"